import React from 'react'
import { Link } from 'react-router'

export default () => (
	<div
		style={{
			textAlign: "center"
		  , paddingTop: "80px"
		}}
	>
		<h1>404 - page not found</h1>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Errors/Error404.js